import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminTypicalProjectInformationItems = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.TYPICAL_PROJECT_INFORMATION_ITEMS.GET_ALL, { params });
    return response.data;
};

export const getAdminTypicalProjectInformationItemById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.TYPICAL_PROJECT_INFORMATION_ITEMS.GET_BY_ID(id));
    return response.data;
};

export const createTypicalProjectInformationItem = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.TYPICAL_PROJECT_INFORMATION_ITEMS.CREATE, data);
    return response.data;
};

export const updateTypicalProjectInformationItem = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.TYPICAL_PROJECT_INFORMATION_ITEMS.UPDATE(id), data);
    return response.data;
};

export const deleteTypicalProjectInformationItem = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.TYPICAL_PROJECT_INFORMATION_ITEMS.DELETE(id));
    return response.data;
};
